import { render, staticRenderFns } from "./ChateaProRedirect.vue?vue&type=template&id=287f2181&"
import script from "./chatea-pro-redirect.ts?vue&type=script&lang=ts&"
export * from "./chatea-pro-redirect.ts?vue&type=script&lang=ts&"
import style0 from "./ChateaProRedirect.vue?vue&type=style&index=0&id=287f2181&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports